import { isNotNullOrUndefined } from "../../../services/util";

export default function getLatestARMBox(armBoxes) {
  const windows = ['EOY', 'MOY', 'BOY'];
  for (const window of windows) {
    const armBox = armBoxes[window];
    if (isNotNullOrUndefined(armBox.score)) return armBox;
  }
  return armBoxes['BOY'];
}